import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EXPIRATION_PROMOTIONS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getProductExpirationPromotionAction = createAsyncThunk(
    'price/getProductExpirationPromotion',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ EXPIRATION_PROMOTIONS_PATH }/next-or-active${ buildQueryString(data) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductExpirationPromotionSlice = createSlice({
    name: 'getProductExpirationPromotionSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateExpirationPromotions() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getProductExpirationPromotionAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductExpirationPromotionAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductExpirationPromotionAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateExpirationPromotions } = getProductExpirationPromotionSlice.actions;
export const getProductExpirationPromotionState = (state) => state.price.getProductExpirationPromotion;
export default getProductExpirationPromotionSlice.reducer;
